// Module
var code = "<md-button class=\"abx-qr-scanner md-icon-button\" aria-label=\"Scan QR Code\" ng-disabled=\"vm.disabled\" ng-click=\"vm.handleClick()\"> <md-tooltip> Scan QR Code </md-tooltip> <md-icon class=\"material-icons\" md-svg-src=\"img/qrcode-scan.svg\"> </md-icon> </md-button> ";
// Exports
module.exports = code;